import * as z from "zod";

const timelineEventSchema = z.object({
  action: z.string().nullish(),
  appTitle: z.string().nullish(),
  attributeToApp: z.string().nullish(),
  createdAt: z.string(),
  message: z.string().nullish(),
});

export const getOrderTimeline = {
  name: "getOrderTimeline" as const,
  input: z.object({ orderNumber: z.string(), teamId: z.string() }),
  output: z.object({ timeline: z.array(timelineEventSchema) }),
};
